import React, { Fragment, useState } from "react";
import logo from "../../../assets/images/1024_1024.png";
import { FaCheck } from "react-icons/fa";

const LetterTemplates = ({ showAllCards = false, defaultSelected = "2" }) => {
  const [selectedCard, setSelectedCard] = useState(defaultSelected); // Allow default selection

  const handleSelect = (value) => {
    setSelectedCard(value);
  };

  return (
    <div className="flex flex-col gap-2">
      {showAllCards ? (
        <Fragment>
          {/* <CardType1
            isSelected={selectedCard === "1"}
            onChange={() => handleSelect("1")}
          /> */}
          <CardType2
            isSelected={selectedCard === "2"}
            onChange={() => handleSelect("2")}
          />
          {/* <CardType3
            isSelected={selectedCard === "3"}
            onChange={() => handleSelect("3")}
          />
          <CardType4
            isSelected={selectedCard === "4"}
            onChange={() => handleSelect("4")}
          />
          <CardType5
            isSelected={selectedCard === "5"}
            onChange={() => handleSelect("5")}
          /> */}
        </Fragment>
      ) : (
        <Fragment>
          {selectedCard === "1" && <CardType1 isSelected />}
          {selectedCard === "2" && <CardType2 isSelected />}
          {selectedCard === "3" && <CardType3 isSelected />}
          {selectedCard === "4" && <CardType4 isSelected />}
          {selectedCard === "5" && <CardType5 isSelected />}
        </Fragment>
      )}
    </div>
  );
};

// Card Components
const CardType1 = ({ isSelected, onChange }) => (
  <div
    onClick={onChange}
    className={`relative flex flex-row items-center gap-2 border rounded-md p-4 cursor-pointer ${
      isSelected ? "border-primary-800" : "border-gray-300"
    }`}
  >
    {isSelected ? (
      <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-20 rounded-md">
        <p className="text-white text-2xl font-bold">Selected</p>
      </div>
    ) : null}
    <div className="w-14 h-14">
      <img src={logo} alt="logo" />
    </div>
    <div className="flex flex-col flex-1">
      <p className="font-bold">BYDO</p>
      <p>C-201, Phase 8B, Industrial Area, Sector 74, Punjab 140308</p>
      <p>www.synswift.com</p>
    </div>
  </div>
);

const CardType2 = ({ isSelected, onChange }) => {
  return (
    <div
      onClick={onChange}
      className={`relative flex flex-row gap-2 items-center justify-between text-theme w-full`}
    >
      {/* {isSelected ? (
        <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-20 rounded-md">
          <p className="text-white text-xl font-bold flex flex-col items-center">
            <FaCheck className="text-xl" />
            <span className="text-sm leading-4">Selected</span>
          </p>
        </div>
      ) : null} */}
      <div className={`flex-1 flex flex-row items-center gap-2 rounded-md p-4 bg-light`}>
        <div className={` w-14 h-14`}>
          <img src={logo} alt="logo" />
        </div>
        <div className={`flex flex-row justify-between flex-1`}>
          <div className={`flex flex-col `}>
            <p className={`font-bold `}>BYDO</p>
            <p className={``}>www.synswift.com</p>
          </div>
          <p className={`w-64 `}>
            C-201, Phase 8B, Industrial Area, Sector 74, Sahibzada Ajit Singh
            Nagar, Punjab 140308
          </p>
        </div>
      </div>
    </div>
  );
};
const CardType3 = ({ isSelected, onChange }) => {
  return (
    <div
      onClick={onChange}
      className={` flex flex-row gap-2 items-center justify-between text-theme w-full`}
    >
      <div
        className={`flex-1 flex flex-col items-center justify-center gap-2 border rounded-md p-4 ${
          isSelected ? "border border-primary-800 rounded-md" : ""
        }`}
      >
        <div className={` w-14 h-14`}>
          <img src={logo} alt="logo" />
        </div>
        <div className={`flex flex-col items-center flex-1`}>
          <p className={`font-bold `}>BYDO</p>
          <div className={`flex flex-row justify-between items-end`}>
            <p className={`w-64 `}>
              C-201, Phase 8B, Industrial Area, Sector 74, Sahibzada Ajit Singh
              Nagar, Punjab 140308
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
const CardType4 = ({ isSelected, onChange }) => {
  return (
    <div
      onClick={onChange}
      className={` flex flex-row gap-2 items-center justify-between text-theme w-full`}
    >
      <div
        className={`flex-1 flex flex-row items-center justify-between border rounded-md p-4 ${
          isSelected ? "border border-primary-800 rounded-md" : ""
        }`}
      >
        <div className={` w-14 h-14`}>
          <img src={logo} alt="logo" />
        </div>
        <div className={`flex flex-col`}>
          <p className={`font-bold `}>BYDO</p>
          <div className={`flex flex-row justify-between items-end`}>
            <p className={`w-64 `}>
              C-201, Phase 8B, Industrial Area, Sector 74, Sahibzada Ajit Singh
              Nagar, Punjab 140308
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
const CardType5 = ({ isSelected, onChange }) => {
  return (
    <div
      onClick={onChange}
      className={` flex flex-row gap-2 items-center justify-between text-theme w-full`}
    >
      <div
        className={`flex-1 flex flex-row-reverse items-center justify-between border rounded-md p-4 ${
          isSelected ? "border border-primary-800 rounded-md" : ""
        }`}
      >
        <div className={` w-14 h-14`}>
          <img src={logo} alt="logo" />
        </div>
        <div className={`flex flex-col`}>
          <p className={`font-bold `}>BYDO</p>
          <div className={`flex flex-row justify-between items-end`}>
            <p className={`w-64 `}>
              C-201, Phase 8B, Industrial Area, Sector 74, Sahibzada Ajit Singh
              Nagar, Punjab 140308
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LetterTemplates;
